import type { CityConfig } from "../city-template/types";

export const englewoodCoConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Englewood",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "englewood-co",
  route: "/englewood-co",
  title: "Emergency Passport Englewood, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Englewood, Colorado — as fast as 24 hours. Same-day courier processing for Englewood, Littleton, Sheridan, Greenwood Village, and all south Denver metro travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Englewood, CO",
  heroSubtitle: "Business trip to Europe departing from DIA and your passport just expired? Swedish Medical Center conference in Stockholm with last-minute travel documents needed? We help Englewood residents — from Denver Tech Center professionals to south Broadway families to Cherry Hills Village homeowners — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Englewood%20Colorado%20suburban%20landscape%20with%20the%20Denver%20Tech%20Center%20skyline%20in%20the%20distance%2C%20modern%20office%20buildings%20and%20glass%20towers%20against%20the%20Rocky%20Mountain%20foothills%2C%20tree%20lined%20residential%20streets%20in%20Arapahoe%20County%2C%20the%20South%20Platte%20River%20corridor%20with%20greenway%20trails%2C%20warm%20afternoon%20Colorado%20light%20with%20dramatic%20cloud%20formations%2C%20professional%20architectural%20photography%2C%20no%20visible%20text%20or%20people%2C%20wide%20panoramic%20view&width=1800&height=700&seq=englewood-co-hero-001&orientation=landscape",
  heroImageAlt: "Englewood Colorado with Denver Tech Center skyline and Rocky Mountain foothills backdrop",
  geoPosition: "39.6478;-104.9875",
  geoPlacename: "Englewood, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 15 miles northeast — about 25 minutes via I-25 and I-225",
  },
  nearbyCitiesZips: [
    { name: "Englewood", zips: "80110, 80111, 80112, 80113, 80150, 80151, 80155" },
    { name: "Littleton", zips: "80120, 80121, 80122, 80123, 80124, 80125, 80126, 80127, 80128, 80129, 80130, 80160, 80161, 80162, 80163, 80165, 80166" },
    { name: "Sheridan", zips: "80110" },
    { name: "Greenwood Village", zips: "80111, 80112, 80121, 80155" },
    { name: "Cherry Hills Village", zips: "80111, 80113" },
    { name: "Centennial", zips: "80111, 80112, 80121, 80122" },
    { name: "Denver Tech Center", zips: "80111, 80112" },
    { name: "Highlands Ranch", zips: "80124, 80126, 80129, 80130" },
    { name: "Lone Tree", zips: "80124" },
    { name: "Bow Mar", zips: "80123" },
    { name: "Columbine Valley", zips: "80123" },
    { name: "Lakewood", zips: "80226, 80227, 80228, 80232" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent DTC business travel and Denver metro international departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — just 15 miles to the Colorado Passport Agency" },
    { icon: "ri-building-line", title: "DTC & Business Travel", desc: "Specialized service for Denver Tech Center professionals and corporate travelers" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in Englewood, DTC, or Littleton" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/denver" },
    { name: "Emergency passport help in Littleton, CO", route: "/littleton" },
    { name: "Fast passport renewal in Centennial, CO", route: "/centennial" },
    { name: "Urgent passport services for Greenwood Village", route: "/englewood-co" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
    { name: "Passport courier services in DTC and Cherry Hills", route: "/englewood-co" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Englewood remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Englewood's proximity to the Colorado Passport Agency (just 15 miles) means our couriers can reach the agency quickly — but you never need to make the drive yourself.",
  fpcOfficeAddress: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
  fpcOfficeDistance: "Serving all of Arapahoe County and the south Denver metro area",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Englewood and the south Denver metro. From the Denver Tech Center and Inverness business parks to the residential neighborhoods along South Broadway and Hampden, from Swedish Medical Center to the Cherry Hills area — we serve every corner of Englewood and the surrounding Arapahoe County communities.",
  nearbyCitiesIntro: "We serve Englewood and all nearby south Denver metro communities including Littleton, Sheridan, Greenwood Village, Cherry Hills Village, Centennial, the Denver Tech Center, Highlands Ranch, Lone Tree, Bow Mar, and Columbine Valley. Lakewood and Denver are also covered through our metro service network.",
  howItWorksIntro: "Most Englewood travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — no need to drive to Aurora, though the agency is just 15 miles away.",
  mistakesIntro: "Englewood is home to the Denver Tech Center and thousands of professionals who travel internationally for business. Here are the most common passport mistakes we see from south metro travelers.",
  testimonialsIntro: "Englewood travelers — from DTC executives to Swedish Medical Center staff to south Broadway families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Englewood, CO? Here are the most common ones we hear from south Denver metro travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Drive to Aurora Passport Agency (25 min via I-25/I-225)", "Subject to availability — no guarantees"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No drive needed — ship from Englewood or DTC", "Perfect for business travel and European vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Englewood travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest passport service in the south metro area.",
      bullets: ["24–48 hour turnaround available", "DTC business travel and DIA departure support", "European and Asian travel expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Englewood adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Englewood or DTC address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Englewood residents and south metro families — including young professionals and new citizens.",
      bullets: ["Acceptance facility scheduling in Englewood or Littleton", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Englewood residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Englewood and south metro families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Englewood and Arapahoe County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Englewood CO", description: "Urgent passport processing for Englewood Colorado travelers with immediate departure needs from DIA." },
    { name: "Expedited Passport Renewal Englewood CO", description: "Fast passport renewal for Englewood Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Englewood CO", description: "New passport application services for Englewood Colorado residents applying for their first passport." },
    { name: "Child Passport Englewood CO", description: "Minor passport services for Englewood Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Michael D.",
      location: "Englewood, CO — DTC",
      rating: 5,
      text: "Last-minute client meeting in London and my passport was expired. Fast Passport Center got it renewed in 2 days. I shipped from the DTC UPS Store during my lunch break. Landed at Heathrow with a fresh passport.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Rebecca S.",
      location: "Cherry Hills Village, CO",
      rating: 5,
      text: "Family ski trip to Switzerland over winter break. Three passports — mine and both teenagers'. Fast Passport Center handled everything in 5 business days. The courier service made it effortless.",
      service: "Family Passport Bundle",
    },
    {
      name: "David L.",
      location: "Littleton, CO — near Swedish",
      rating: 5,
      text: "Medical mission trip to Guatemala and my passport had expired. Fast Passport Center expedited my renewal in 3 days. The document review caught an error I would have missed. Truly professional service.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Jennifer K.",
      location: "Englewood, CO — South Broadway",
      rating: 5,
      text: "Lost my passport two weeks before a trip to Japan for my daughter's wedding. Fast Passport Center replaced it in 48 hours. I was at the ceremony with time to spare. Forever grateful.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "englewood-co-1",
      name: "Englewood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3330 S Broadway",
      city: "Englewood",
      state: "CO",
      zip: "80113",
      phone: "(303) 789-2211",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Central Englewood, on South Broadway",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Englewood acceptance facility. Appointments required. Convenient for South Broadway corridor residents and businesses.",
      icon: "ri-mail-line",
    },
    {
      id: "englewood-co-2",
      name: "Littleton Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5753 S Prince St",
      city: "Littleton",
      state: "CO",
      zip: "80120",
      phone: "(303) 798-1411",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Downtown Littleton, approximately 4 miles south of Englewood",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Large facility serving Littleton and south metro. Extended hours compared to some locations. Popular with historic downtown Littleton residents.",
      icon: "ri-mail-line",
    },
    {
      id: "englewood-co-3",
      name: "Greenwood Village Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6800 S Potomac St",
      city: "Centennial",
      state: "CO",
      zip: "80112",
      phone: "(303) 790-5311",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "DTC area, approximately 5 miles southeast of Englewood",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves DTC, Greenwood Village, and Inverness business park. Ideal for professionals who prefer a lunch-time appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "englewood-co-4",
      name: "Arapahoe County Clerk — Littleton",
      type: "County Clerk Passport Acceptance",
      address: "5334 S Prince St",
      city: "Littleton",
      state: "CO",
      zip: "80120",
      phone: "(303) 795-4200",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Littleton, near the Arapahoe County Courthouse",
      website: "https://www.arapahoegov.com/",
      websiteLabel: "Arapahoe County Clerk",
      notes: "County clerk passport acceptance with morning hours starting at 8:00 AM. Convenient for early appointments before work.",
      icon: "ri-government-line",
    },
    {
      id: "englewood-co-5",
      name: "Centennial Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7505 S University Blvd",
      city: "Centennial",
      state: "CO",
      zip: "80122",
      phone: "(303) 730-6241",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Centennial, approximately 6 miles south of Englewood",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Centennial and south Arapahoe County residents. Serves the Southglenn and University areas.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 25 min drive to Aurora via I-25/I-225", fpc: "No — ship from Englewood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "I-25 Traffic", agency: "Heavy rush hour traffic — unpredictable", fpc: "No driving needed — courier handles it" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "DTC professionals often assume expedited service can be started 2 days before a business trip. While 24–48 hour processing is available, starting with more buffer is always better. Book at least 2 weeks before travel.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "DTC-area photo services sometimes produce photos for corporate badges rather than passports. Passport photos must be exactly 2×2 inches on a white background — no exceptions, no headshots, no company-logo backgrounds.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Checking Appointment Availability",
      description: "South metro post offices book up quickly — especially the Littleton Main Post Office and Greenwood Village location. Book your acceptance facility appointment 1–2 weeks in advance.",
    },
    {
      icon: "ri-building-line",
      title: "Business Visa Confusion",
      description: "Many DTC companies have employees traveling to countries requiring both a passport AND a business visa. A passport alone isn't enough. Verify visa requirements before booking flights.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Many European and Asian countries require 6 months of passport validity beyond your stay. DTC business travelers to the EU, China, and Japan often discover this requirement days before departure.",
    },
    {
      icon: "ri-file-list-line",
      title: "Using Damaged Passports",
      description: "Water damage, torn pages, or loose covers render a passport invalid. Many Englewood travelers don't realize minor damage disqualifies their passport until they're at the airport.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your desk in DTC or home in Englewood." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Englewood, DTC, or Littleton." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — catching errors the post office would miss." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no I-25/I-225 drive required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Englewood or DTC office address — trackable every step." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Englewood, CO?", a: "Fast Passport Center offers emergency passport processing in Englewood, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — often the Colorado Passport Agency just 15 miles away." },
    { q: "Does Englewood have its own passport agency?", a: "No — Englewood does not have a regional passport agency. The nearest is the Colorado Passport Agency in Aurora (15 miles northeast via I-25 and I-225). Fast Passport Center's courier service means you never need to make the drive yourself." },
    { q: "Can I get a passport near the Denver Tech Center?", a: "Yes. Fast Passport Center serves the entire DTC and Inverness business park area. The Greenwood Village Post Office (6800 S Potomac St) is the closest acceptance facility for DTC professionals. We can coordinate everything from your office." },
    { q: "Do you serve Greenwood Village and Cherry Hills Village?", a: "Absolutely. Fast Passport Center serves all south metro communities including Greenwood Village, Cherry Hills Village, Centennial, Highlands Ranch, Lone Tree, Bow Mar, and Columbine Valley. Our service is identical across the entire area." },
    { q: "How much does an expedited passport cost in Englewood, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Englewood?", a: "Walgreens (3601 S Broadway), CVS (201 W Hampden Ave), and FedEx Office (9600 E Arapahoe Rd in Greenwood Village) offer passport photo services. The UPS Store at 9609 E Arapahoe Rd also provides photos. Photos must be 2×2 inches on a white background." },
    { q: "What's the quickest way to get to the Colorado Passport Agency from Englewood?", a: "Take I-25 north to I-225 north, then exit at Iliff Avenue. The Colorado Passport Agency is at 3151 S Vaughn Way in Aurora. The drive takes approximately 25 minutes without traffic, but can exceed 45 minutes during rush hour. Our courier service eliminates this trip entirely." },
    { q: "Can you help with passports for Swedish Medical Center staff traveling internationally?", a: "Yes. Fast Passport Center serves all Englewood healthcare professionals including Swedish Medical Center and Craig Hospital staff. We understand the demands of medical careers and can coordinate expedited passport services around your schedule." },
  ],
  photoLocations: [
    { name: "Walgreens — Englewood", address: "3601 S Broadway, Englewood, CO 80113", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com" },
    { name: "CVS Pharmacy — Englewood", address: "201 W Hampden Ave, Englewood, CO 80110", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com" },
    { name: "FedEx Office — Greenwood Village", address: "9600 E Arapahoe Rd, Greenwood Village, CO 80112", hours: "Mon–Fri: 7AM–9PM, Sat: 9AM–6PM", website: "https://www.office.fedex.com" },
    { name: "UPS Store — Greenwood Village", address: "9609 E Arapahoe Rd, Greenwood Village, CO 80112", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com" },
  ],
  dmvLocations: [
    { name: "DMV — Littleton (Arapahoe County)", address: "5334 S Prince St, Littleton, CO 80120", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV for Arapahoe County residents. REAL ID and driver's license renewals. Convenient downtown Littleton location.", featured: true },
    { name: "DMV — Centennial (Arapahoe County)", address: "6954 S Lima St, Centennial, CO 80112", hours: "Mon–Fri: 8AM–5PM", note: "Alternative Arapahoe County DMV near DTC. REAL ID processing available. Serves Centennial and Greenwood Village.", featured: false },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "30 miles northeast of Englewood via I-225 and Pena Blvd",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport with nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Approximately 35–45 minutes from Englewood.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "APA",
      name: "Centennial Airport",
      distance: "8 miles south of Englewood via I-25",
      address: "7800 S Peoria St, Englewood, CO 80112",
      note: "General aviation and private jet airport. One of the busiest general aviation airports in the country. No commercial flights. Convenient for private aviation travelers in the south metro area.",
      flightUrl: "https://www.centennialairport.com/",
      flightLabel: "APA Flight Info",
      featured: false,
    },
  ],
};